import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import editorStyle from "../util/defaultStyle";
export default function (G6) {
  G6.registerBehavior('dragNode', {
    getDefaultCfg: function getDefaultCfg() {
      return {
        updateEdge: true,
        delegate: true,
        delegateStyle: {},
        align: true
      };
    },
    getEvents: function getEvents() {
      return {
        'node:dragstart': 'onDragStart',
        'node:drag': 'onDrag',
        'node:dragend': 'onDragEnd'
      };
    },
    onDragStart: function onDragStart(e) {
      if (!this.shouldBegin.call(this, e)) {
        return;
      }
      this.target = e.item;
      this.origin = {
        x: e.x,
        y: e.y
      };
    },
    onDrag: function onDrag(e) {
      if (!this.origin) {
        return;
      }
      if (!this.get('shouldUpdate').call(this, e)) {
        return;
      }
      var origin = this.origin;
      var groupId = this.target.get('groupId');
      var model = this.target.get('model');
      if (!this.point) {
        this.point = {
          x: model.x,
          y: model.y
        };
      }
      if (groupId) {
        var subProcessNode = this.graph.findById(groupId);
        var subProcessBBox = subProcessNode.getBBox();
        var x = e.x - origin.x + this.point.x + subProcessBBox.x + subProcessBBox.width / 2;
        var y = e.y - origin.y + this.point.y + subProcessBBox.y + subProcessBBox.height / 2;
        this.origin = {
          x: e.x,
          y: e.y
        };
        this.point = {
          x: x - subProcessBBox.x - subProcessBBox.width / 2,
          y: y - subProcessBBox.y - subProcessBBox.height / 2
        };
        if (this.delegate) {
          this._updateDelegate(this.target, x, y);
        }
      } else {
        var _x = e.x - origin.x + this.point.x;
        var _y = e.y - origin.y + this.point.y;
        this.origin = {
          x: e.x,
          y: e.y
        };
        this.point = {
          x: _x,
          y: _y
        };
        if (this.delegate) {
          this._updateDelegate(this.target, _x, _y);
        }
      }
    },
    onDragEnd: function onDragEnd(e) {
      if (!this.shouldEnd.call(this, e)) {
        return;
      }
      if (!this.origin) {
        return;
      }
      var delegateShape = e.item.get('delegateShape');
      var groupId = this.target.get('groupId');
      if (groupId) {
        if (delegateShape) {
          var subProcessNode = this.graph.findById(groupId);
          var subProcessBBox = subProcessNode.getBBox();
          var bbox = delegateShape.getBBox();
          var x = bbox.x + bbox.width / 2 - subProcessBBox.x - subProcessBBox.width / 2;
          var y = bbox.y + bbox.height / 2 - subProcessBBox.y - subProcessBBox.height / 2;
          delegateShape.remove();
          this.target.set('delegateShape', null);
          var group = subProcessNode.getContainer();
          var id = this.target.get('id');
          var resultModel = group.updateNodeModel(subProcessNode, id, {
            x: x,
            y: y
          });
          this._updateItem(subProcessNode, resultModel);
        }
      } else {
        if (delegateShape) {
          var _bbox = delegateShape.getBBox();
          var _x2 = _bbox.x + _bbox.width / 2;
          var _y2 = _bbox.y + _bbox.height / 2;
          delegateShape.remove();
          this.target.set('delegateShape', null);
          this._updateItem(this.target, {
            x: _x2,
            y: _y2
          });
        }
      }
      this.point = null;
      this.origin = null;
      this.graph.emit('afternodedragend', this.target);
    },
    _updateItem: function _updateItem(item, point) {
      if (this.graph.executeCommand) {
        this.graph.executeCommand('update', {
          itemId: item.get('id'),
          updateModel: point
        });
      } else {
        if (this.get('updateEdge')) {
          this.graph.updateItem(item, point);
        } else {
          item.updatePosition(point);
          this.graph.paint();
        }
      }
    },
    _updateDelegate: function _updateDelegate(item, x, y) {
      var self = this;
      var shape = item.get('delegateShape');
      var bbox = item.get('keyShape').getBBox();
      if (!shape) {
        var parent = self.graph.get('group');
        var attrs = editorStyle.nodeDelegationStyle;
        // model上的x, y是相对于图形中心的，delegateShape是g实例，x,y是绝对坐标
        shape = parent.addShape('rect', {
          attrs: _objectSpread({
            width: bbox.width,
            height: bbox.height,
            x: x - bbox.width / 2,
            y: y - bbox.height / 2,
            nodeId: item.get('id')
          }, attrs)
        });
        shape.set('capture', false);
        item.set('delegateShape', shape);
      }
      shape.attr({
        x: x - bbox.width / 2,
        y: y - bbox.height / 2
      });
      this.graph.paint();
      this.graph.emit('afternodedrag', shape);
    }
  });
}